import { MarketplaceSaleChannelType } from '@anyx/common-graphql';
import { TitledIcon } from '@anyx/shared-ui';
import { EMPTY_DEFAULT } from '@anyx/shared-utils';

import { AliasedSaleChannelData, ChannelUtils, getChannelIcon } from '../../utils';

type ChannelSorterProps = {
  id?: string | null;
  data?: AliasedSaleChannelData;
  type?: MarketplaceSaleChannelType | null;
};

export const ChannelSorter = ({
  channels,
  ignoreChannel = [],
}: {
  channels: ChannelSorterProps[];
  ignoreChannel?: MarketplaceSaleChannelType[];
}) => {
  return (
    <div className="flex">
      {ChannelUtils.sortChannels({
        channels,
        byField: 'type',
        disabled: ignoreChannel,
      }).map((channel, idx) => {
        return (
          <span key={`${channel.id}-${idx}`} className="relative mt-1 mr-2">
            {channel?.type ? (
              <TitledIcon
                icon={getChannelIcon(channel.type, 'fa')}
                text={ChannelUtils.getCountry(channel.data)}
              />
            ) : (
              EMPTY_DEFAULT
            )}
          </span>
        );
      })}
    </div>
  );
};
